export default function parseInterval(interval) {
  return interval ? interval - 1 : 0;
}
